import type { TurnstileInstance } from '@marsidev/react-turnstile';
import { useRef, useState } from 'react';

const useTurnstile = () => {
  const turnstileRef = useRef<TurnstileInstance>(null);
  const [turnstileToken, setTurnstileToken] = useState<string>();

  const resetTurnstile = () => {
    turnstileRef.current?.reset();
    setTurnstileToken(undefined);
  };

  return {
    setTurnstileToken,
    resetTurnstile,
    turnstileRef,
    turnstileToken,
  };
};

export default useTurnstile;
